const escapeCsv = (value) => {
  const text = String(value ?? "");
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const formatAmount = (value) =>
  value == null || value === "" ? "0.00" : Number(value).toFixed(2);

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString() : "";

export const downloadGeneralLedgerCsv = ({
  rows = [],
  periodName = "",
  accountCode = "",
  t,
}) => {
  const lines = [
    [t("accounting.financeReports.generalLedger.title")],
    [t("Fiscal Period"), periodName],
    [t("accounting.journal.account"), accountCode || t("accounting.financeReports.generalLedger.allAccounts")],
    [],
    [
      t("Date"),
      t("Code"),
      t("accounting.journal.account"),
      t("Description"),
      t("accounting.journal.source"),
      t("Debit"),
      t("Credit"),
      t("accounting.financeReports.generalLedger.runningBalance"),
    ],
    ...rows.map((row) => [
      formatDate(row.entryDate),
      row.journalCode,
      `${row.accountCode} ${row.accountName || ""}`.trim(),
      row.description,
      row.sourceType
        ? `${row.sourceType}${row.eventType ? ` / ${row.eventType}` : ""}`
        : "",
      formatAmount(row.debit),
      formatAmount(row.credit),
      formatAmount(row.runningBalance),
    ]),
  ];

  const csv = `\uFEFF${lines.map((line) => line.map(escapeCsv).join(",")).join("\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `general-ledger-${accountCode || periodName || stamp}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
